export default "__VITE_ASSET__89fd5558__"